const getDefaultState = () => ({
  element: {
    show: false,
    identifier: null,
    message: null,
    button: null,
    timeout: 4000,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/snackbar/defaultState.js